import HTTPError from "src/errors/http-error";

export default class ApiError extends HTTPError {}
